var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-input",
        _vm._b(
          {
            attrs: {
              readonly: "readonly",
              "suffix-icon": "el-icon-arrow-down",
            },
            nativeOn: {
              click: function ($event) {
                return _vm.onClick.apply(null, arguments)
              },
            },
            model: {
              value: _vm.changeSelectValue,
              callback: function ($$v) {
                _vm.changeSelectValue = $$v
              },
              expression: "changeSelectValue",
            },
          },
          "el-input",
          Object.assign({}, _vm.item),
          false
        )
      ),
      _c(
        "van-popup",
        {
          attrs: {
            round: "",
            closeable: "",
            "lazy-render": "",
            position: "bottom",
          },
          model: {
            value: _vm.showPicker,
            callback: function ($$v) {
              _vm.showPicker = $$v
            },
            expression: "showPicker",
          },
        },
        [
          _c("div", [
            _c("div", { staticClass: "title" }, [
              _c("b", [_vm._v(_vm._s(_vm.item.placeholder || "请选择"))]),
            ]),
            _c(
              "div",
              [
                _c("van-search", {
                  attrs: {
                    placeholder: "请输入搜索关键词",
                    clearable: "",
                    "show-action": "",
                  },
                  on: { search: _vm.handleSearch, clear: _vm.handleClear },
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "search_btn",
                              on: {
                                click: function ($event) {
                                  return _vm.handleSearch()
                                },
                              },
                            },
                            [_vm._v("搜索")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.keyWords,
                    callback: function ($$v) {
                      _vm.keyWords = $$v
                    },
                    expression: "keyWords",
                  },
                }),
              ],
              1
            ),
            _c("div", { ref: "selectBody", staticClass: "select-body" }, [
              _c(
                "dl",
                { staticClass: "select-option" },
                _vm._l(_vm.options, function (option) {
                  return _c(
                    "dd",
                    {
                      key: option.value,
                      staticClass: "select-option-item",
                      class:
                        _vm.value == option.value
                          ? "select-option-item-checked"
                          : "",
                      on: {
                        click: function ($event) {
                          return _vm.onConfirm(option.value)
                        },
                      },
                    },
                    [_c("i"), _c("div", [_vm._v(_vm._s(option.label))])]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }